module.exports = __webpack_public_path__ + "static/media/error-default.600e7702.svg";